import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/cloud-storage")({
  staticData: {
    title: "edge.navigation.cloudStorage",
  },
});
